import { client } from 'pioneira-ui';
import axios from 'axios';

export default {
  namespaced: true,
  actions: {
    getPaises(context) {
      return client.get(`/api/listas/paises`);
    },

    getAllEstados(context) {
      return client.get(`/api/listas/estados`);
    },

    getEstadoIdByCodigoIbge(context, codigoIbge) {
      return client.get(`/api/listas/estado-id-by-ibge/${codigoIbge}`);
    },

    getAllCidades(context, idEstado) {
      return client.get(`/api/listas/cidades/${idEstado}`);
    },

    getCidadeIdByCodigoIbge(context, codigoIbge) {
      return client.get(`/api/listas/cidade-id-by-ibge/${codigoIbge}`);
    },

    getEnderecoCep(context, cep) {
      return axios.get(`https://viacep.com.br/ws/${cep}/json/`);
    },

    getMunicipioIbge(context, id) {
      return axios.get(
        `https://servicodados.ibge.gov.br/api/v1/localidades/municipios/${id}`
      );
    },
  },
};
